const PREFIX = 'uf/debug';
export const SET_DEBUG_FLAG = `${PREFIX}/SET_DEBUG_VALUE`;
